import type { Die } from '../die.type';
import { Modifier } from '../modifier';
import {
  ModifierPriority,
  ModifierTags,
  StatusEffect,
  type ModifierParams,
} from '../modifier.type';
import { StatusEffectRegistry } from '../status-effects';
import type { Player } from '../player.type';

export class Powerful extends Modifier {
  static readonly baseTitle = 'Powerful';
  static readonly baseText = 'Upgrades a die at the start of turn per stack. Stable.';
  static readonly baseIcon = 'fist';
  static readonly baseTags = [ModifierTags.Boon];
  static readonly basePriority = ModifierPriority.Middle;

  // Instance properties that can change
  title = Powerful.baseTitle;
  text = Powerful.baseText;
  icon = Powerful.baseIcon;
  tags: Array<ModifierTags> = [...Powerful.baseTags];
  priority = Powerful.basePriority;

  update(stacks: number, params: ModifierParams) {
    super.update(stacks, params);
    this.delay = true;
  }

  endTurn() {
    if (this.delay) {
      const focus = this.owner.statusEffects.find(
        (modifier) => modifier.type === StatusEffect.Focus,
      );
      if (!focus) {
        this.delay = false;
      }
    } else {
      this.removeStacks(1);
    }
  }

  startTurn({
    dice,
    rerollMax,
    activePlayer,
    inactivePlayer,
  }: {
    dice: Array<Die>;
    rerollMax: number;
    activePlayer: Player;
    inactivePlayer: Player;
  }): void | { dice: Array<Die>; rerollMax: number; activePlayer: Player; inactivePlayer: Player } {
    let remainingStacks = this.stacks;
    while (remainingStacks > 0) {
      // Find all dice below level 2
      const eligibleDice = dice.filter((die: Die) => die.level < 2);

      if (eligibleDice.length === 0) {
        break; // No more dice to upgrade
      }

      // Pick a random eligible die
      const die = eligibleDice[Math.floor(Math.random() * eligibleDice.length)];
      die.setLevel(die.level + 1);
      remainingStacks--;
    }

    return { dice, rerollMax, activePlayer, inactivePlayer };
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Powerful, Powerful);
